import { styled } from '@mui/material/styles'
import { Link as GatsbyLink } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'

// Define the default function outside the component to prevent ESLint error
const defaultOnClick = () => {}

// Styled Component using MUI's `styled` API
const StyledLink = styled(GatsbyLink, {
  shouldForwardProp: (prop) => prop !== 'isTitleLink' && prop !== 'imageLink',
})(({ theme, isTitleLink, imageLink }) => ({
  cursor: 'pointer',
  textDecoration: 'none',
  color: 'inherit',
  height: imageLink ? '100%' : 'auto',
  display: isTitleLink ? 'flex' : 'unset',
  flexDirection: isTitleLink ? 'column' : 'unset',
  flexWrap: isTitleLink ? 'wrap' : 'unset',
  gap: isTitleLink ? '4px' : '0px',
  columnGap: isTitleLink ? '10px' : '0px',
  '&:hover, &:focus': {
    textDecoration: 'underline',
    textDecorationColor: theme.palette.primary.main,
  },
}))

// Main Functional Component
const GatedContent = React.memo(
  ({
    children,
    url,
    customOnClick = defaultOnClick,
    isTitleLink = false,
    imageLink = false,
  }) => {
    const isValidUrl = React.useMemo(
      () => typeof url === 'string' && url.startsWith('/'),
      [url]
    )

    if (!isValidUrl) {
      console.warn(`Invalid URL passed to GatedContent: ${url}`)
      return null
    }

    return (
      <StyledLink
        to={url}
        onClick={customOnClick}
        isTitleLink={isTitleLink}
        imageLink={imageLink}
      >
        {children}
      </StyledLink>
    )
  }
)

GatedContent.propTypes = {
  children: PropTypes.node,
  url: PropTypes.string,
  customOnClick: PropTypes.func,
  isTitleLink: PropTypes.bool,
  imageLink: PropTypes.bool,
}

GatedContent.displayName = 'GatedContent'

export default GatedContent
